import user_icon from 'PMDB/assets/images/icons/icon_user_01.svg';
import lock_icon from 'PMDB/assets/images/icons/icon_login_01.svg'
import { faCircle } from '@fortawesome/free-solid-svg-icons';

export const LINK = 'link';
export const BREAKLINE = 'breakline';
export const HEADLINE = "headline";
export const LINK_BTN = 'linkBtn';
export const CHECKBOX = 'checkbox';
export const LIST = 'list';
export const TXT_BTN = 'txtBtn';
export const NEWTAB_LINK = 'newTabLink';

export const SIGNUP_ITEMS = [
    { name: "email", label: "Email", intl: "auth.email", type: "email", placeholder: "you@example.com" },
    { name: "username", label: "Username", intl: "auth.username", type: "text", placeholder: "johndoe" },
    { name: "fullname", label: "Full Name", intl: "auth.fullname", type: "text", placeholder: "John Doe" },
    { name: "password", label: "Password", intl: "auth.password", type: "password", placeholder: "**********" },
];

export const SIGNUP_TDK_ITEMS = [
    { name: "firstname", label: "Firstname", intl: "auth.firstname", type: "text", isRequired: true },
    { name: "lastname", label: "Lastname", intl: "auth.lastname", type: "text" },
    { name: "email", label: "Email", intl: "auth.email", type: "email", isRequired: true, rules: { isEmail: true } },
    // { name: "password", label: "Password", intl: "auth.password", type: "password", isRequired: true },
    { name: "company", label: "Company", intl: "auth.company", type: "text", isRequired: true },
    { name: "department", label: "Department", intl: "auth.department", type: "text", isRequired: true },
    { name: "street", label: "Street", intl: "auth.street", type: "text", isRequired: true },
    { name: "city", label: "City", intl: "auth.city", type: "text", isRequired: true },
    { name: "zipcode", label: "ZipCode", intl: "auth.zipcode", type: "text", isRequired: true },
    { name: "country", label: "Country", intl: "auth.country", type: "text", isRequired: true },
];

export const SIGNUP_TDK_SUBTXT_ITEMS = [
    { name: "signup_subtxt1", intl: "auth.signup.subtxt1", type: "text" },
    { name: "signup_subtxt2", intl: "auth.signup.subtxt2", type: "text" },
    // { name: "subtxt3", intl: "auth.subtxt3", type: "text" },
];

export const SIGNIN_ITEMS = [
    { name: "username", intl: "auth.username", type: "text", placeholder: "johndoe", icon: user_icon, isRequired: true },
    { name: "password", intl: "auth.password", type: "password", placeholder: "**********", icon: lock_icon, isRequired: true },
];


export const SIGNIN_TDK_BOTTOM_ITEMS = [
    {
        name: "signin_forgot", intl: "page.auth.link.forgot",
        link: `mailto:support@flowworks.de?subject=PicturePool password reset`,
        before: "auth.signin.contact.before",
        after: "auth.signin.contact.after"
    },
    { name: "breakline", type: "breakline" },
    { name: "signin_contact", intl: "page.auth.link.contact", type: TXT_BTN, show: 'contact' },
];


export const SIGNIN_BOTTOM_ITEMS = [
    { name: "signin_register", intl: "page.auth.link.register", isRegister: true },
    { name: "signin_forgot", intl: "page.auth.link.forgot", isForgot: true },
];

export const SIGNIN_TDK_SUBTXT_ITEMS = [
    { name: "signin_subtxt1", intl: "auth.signin.subtxt1", type: "text" },
    { name: "breakline", type: "breakline" },
    { name: "signin_subtxt2", intl: "auth.signin.subtxt2", type: "text" },
    { name: "breakline", type: "breakline" },
    {
        name: "signin_subtxt3", intl: "auth.signin.subtxt3", type: "linkBtn",
        isRegister: true,
        before: "auth.signin.subtxt3.before",
        after: "auth.signin.subtxt3.after"
    },
    { name: "breakline", type: "breakline" },
];


export const SIGNIN_TDK_INFO_ITEMS = [
    { name: "useofpicture", intl: "auth.signin.useofpicture", type: "headline" },
    { name: "signin_info10", intl: "auth.signin.info10", type: "text" },
    { name: "breakline", type: "breakline" },
    { name: "signin_info20", intl: "auth.signin.info20", type: "text" },
    { name: "breakline", type: "breakline" },
    { name: "signin_info30", before: "auth.signin.info30.before", intl: "auth.signin.info30", type: NEWTAB_LINK, link: "https://www.tdk-electronics.tdk.com/en/terms-of-use" },
    { name: "breakline", type: "breakline" },
    { name: "signin_info40", intl: "auth.signin.info40", type: "text", after: "auth.signin.info40.after", afterClasses: 'signin-bold' },
    { name: "breakline", type: "breakline" },
    {
        name: "signin_info50", before: "auth.signin.info50.before",
        intl: "auth.signin.info50", after: "auth.signin.info50.after", type: "text", htmlClasses: 'signin-bold'
    }, { name: "breakline", type: "breakline" },
    { name: "signin_info60", intl: "auth.signin.info60", type: "text" },
    { name: "breakline", type: "breakline" },
    { name: "signin_info70", intl: "auth.signin.info70", type: "text" },
    { name: "breakline", type: "breakline" },
    { name: "signin_info80", intl: "auth.signin.info80", type: "text", htmlClasses: 'signin-bold' },
    { name: "breakline", type: "breakline" },
    { name: "signin_info100", intl: "auth.signin.info100", type: "text", htmlClasses: 'signin-mt-10' },
    { name: "breakline", type: "breakline" },
    { name: "signin_info110", link: "Felix.Mechernich@tdk.com", intl: "Felix.Mechernich@tdk.com", after: "auth.signin.info110.after", type: "link" },
    { name: "signin_info120", link: "Elke.Herrnbeck@tdk.com", intl: "Elke.Herrnbeck@tdk.com", after: "auth.signin.info120.after", type: "link" },
    { name: "breakline", type: "breakline" },
    { name: "signin_info130", link: "Felix.Mechernich@tdk.com", before: "auth.signin.info130.before", intl: "Felix.Mechernich@tdk.com", after: "auth.signin.info130.after", type: "link" },
];

export const SIGNIN_TDK_CONTACT_ITEMS = [
    {
        name: 'contact_100', intl: 'auth.contact.heading100', type: HEADLINE,
        data: [
            { name: "contact_info110", intl: "auth.contact.info110", type: "text" },
            { name: "contact_info120", intl: "auth.contact.info120", type: "text" },
            { name: "contact_info130", link: "felix.mechernich@tdk.com", intl: "felix.mechernich@tdk.com", before: "auth.contact.info130.before", type: "link" },
            { name: "contact_info140", link: "elke.herrnbeck@tdk.com", intl: "elke.herrnbeck@tdk.com", before: "auth.contact.info140.before", type: "link" },
            { name: "contact_info150", intl: "auth.contact.info150", type: "text" },
            { name: "contact_info160", intl: "auth.contact.info160", type: "text" },
            { name: "contact_info170", intl: "auth.contact.info170", type: "text" },
        ]
    },
    {
        name: 'contact_200', intl: 'auth.contact.heading200', type: HEADLINE,
        data: [
            { name: "contact_info210", intl: "auth.contact.info210", type: "text" },
            { name: "contact_info220", intl: "auth.contact.info220", type: "text" },
            { name: "contact_info230", link: "support@flowworks.de", intl: "support@flowworks.de", type: "link" },
            { name: "contact_info240", intl: "auth.contact.info240", type: "text" },
        ]
    }
]